export default __webpack_public_path__ + "static/media/calf_concat.5b756cf8.mp3";